import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var supportIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.56 20.25a5.82 5.82 0 0 1-3.4-1 1 1 0 0 0-1.26.05l-.46.41a6.85 6.85 0 0 0 5.12 2 7.37 7.37 0 0 0 5-2 1 1 0 0 0-.09-1.51l-.3-.2a5.81 5.81 0 0 1-4.61 2.25Zm17.56-.92a1 1 0 0 0-1.3-.12 5.93 5.93 0 0 1-3.38 1 5.54 5.54 0 0 1-5.69-5.37V4.81l4 4a1 1 0 0 0 1.42 0l.35-.35-6-6a.75.75 0 0 0-1.06 0l-6 6 .35.35a1 1 0 0 0 1.42 0l4-4v10.07a7 7 0 0 0 7.19 6.87 7.33 7.33 0 0 0 5.08-2Z",
  fill: "currentColor"
}));

export { supportIcon as default };
//# sourceMappingURL=supportIcon.js.map
